export default __webpack_public_path__ + "static/media/skis_light.bc951ee9.png";